const toNumber = (value) => {
  if (typeof value === "number") return value;

  const rawValue = String(value ?? "").trim();
  const isParenthesizedNegative = /^\(.*\)$/.test(rawValue);
  const normalized = rawValue.replace(/[^0-9.-]/g, "");
  const parsed = Number.parseFloat(normalized);

  if (Number.isNaN(parsed)) return 0;
  return isParenthesizedNegative ? -Math.abs(parsed) : parsed;
};

export const sortStringNumberWithCommas = (row1, row2, fieldToSort) => {
  const a = toNumber(row1[fieldToSort]);
  const b = toNumber(row2[fieldToSort]);

  if (a > b) return 1;
  if (b > a) return -1;
  return 0;
};

export const matchesText = (value, filter) => {
  if (!filter) return true;
  return String(value ?? "").toLowerCase().includes(String(filter).toLowerCase());
};

export const matchesExactValue = (value, filter) => !filter || value === filter;

export const matchesAmountRange = (value, min, max) => {
  const amount = Number(value || 0);
  const minimum = min === "" ? null : Number(min);
  const maximum = max === "" ? null : Number(max);
  return (minimum === null || amount >= minimum) && (maximum === null || amount <= maximum);
};

